// How a feedback report's parts are shown (features/feedback.md), in the mail to support and on the admin's Feedback
// screen alike. Imports nothing: the web view and the admin's screens bundle it.

// An address as a feedback report keeps it (features/feedback.md, "what helps find it"): the page's path and query,
// but never a secret it carries. A join link's code (/j/…, and the web API's /api/join/…), a friend's pad's (/p/…) and
// an upload's (/api/put/…) are links that work for whoever holds them, so they're kept as "…"; so is the query of the
// screen after signing up (an AI's signed request) and of a data export's file link. The web form and the server's
// own pages (the wrong gate's Report this) both go through here.

const SECRET_PATHS = /^(\/(?:api\/)?(?:j|join|p|put)\/)[^/?#]+/;
const SECRET_QUERIES = /^\/(?:welcome|api\/export-files\/)/;

export function shownAddress(address: string): string {
  const at = address.search(/[?#]/);
  const path = at === -1 ? address : address.slice(0, at);
  const rest = at === -1 ? "" : address.slice(at);
  const shown = path.replace(SECRET_PATHS, "$1…");
  return SECRET_QUERIES.test(path) ? shown : `${shown}${rest.startsWith("#") ? "" : rest.split("#")[0]}`;
}

// The first words of a report, on one line, for a subject: its first sentence (or line) where that's short enough,
// else whole words to at most `max` characters and an ellipsis.
export function firstWords(text: string, max = 60): string {
  const trimmed = text.trim();
  const first =
    trimmed
      .match(/^[^\n]*?[.!?](?=\s|$)|^[^\n]+/)?.[0]
      ?.replace(/\s+/g, " ")
      .trim() ?? "";
  if (first.length >= 12 && first.length <= max) return first.replace(/\.$/, "");
  const line = trimmed.replace(/\s+/g, " ");
  if (line.length <= max) return line;
  const cut = line.slice(0, max);
  const space = cut.lastIndexOf(" ");
  return `${(space > max / 2 ? cut.slice(0, space) : cut).replace(/[\s,;:.–-]+$/, "")}…`;
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// A time as the device gave it (2026-10-25T14:03:12+08:00), as people read it: "25 Oct 2026, 14:03, Asia/Singapore
// (UTC+08:00)"; anything else as it came.
export function shownTime(time: string, zone: string | undefined): string {
  const m = time.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/);
  if (!m) return zone ? `${time} (${zone})` : time;
  const [, y, mo, d, h, mi, offset] = m;
  const utc = offset === "Z" ? "UTC" : `UTC${offset}`;
  return `${Number(d)} ${MONTHS[Number(mo) - 1]} ${y}, ${h}:${mi}, ${zone ? `${zone} (${utc})` : utc}`;
}
